import { Button } from '@/components/ui/button';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuLabel, DropdownMenuRadioGroup,
    DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import { isPlayerKDPeriod, PlayerKDPeriod, playerKDPeriods } from '@shared/playerKD';
import { ChevronsUpDownIcon } from 'lucide-react';

export default function PlayerKDPeriodSelect({ value, onChange, className }: {
    value: PlayerKDPeriod;
    onChange: (period: PlayerKDPeriod) => void;
    className?: string;
}) {
    return <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <Button variant="outline" className={cn(
                'justify-between border-input bg-black/5 dark:bg-black/30 hover:dark:bg-primary', className,
            )}>
                KD
                <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-44">
            <DropdownMenuLabel>Período KD</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuRadioGroup value={value} onValueChange={period => {
                if (isPlayerKDPeriod(period)) onChange(period);
            }}>
                {playerKDPeriods.map(period => <DropdownMenuRadioItem
                    key={period.value} value={period.value} className="cursor-pointer"
                >
                    {period.label}
                </DropdownMenuRadioItem>)}
            </DropdownMenuRadioGroup>
        </DropdownMenuContent>
    </DropdownMenu>;
}
